import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const DeadlocksTransactions = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Deadlocks in Transactions and Handling Techniques"
    videos={[
      "https://www.youtube.com/embed/ee-wg9q29f0?si=nc00oKsGtG-l4kKc",
      "https://www.youtube.com/embed/b907ttJsfts?si=R9tjbQ4QEPsq1hBW",
      "https://www.youtube.com/embed/WZtebOyiu0M?si=L0LoHexuhzcDP05v",
      "https://www.youtube.com/embed/I5KXDLchg18?si=6IDdolyZHGjb6Y6K"
    ]}
    takeaways={[]}
    questions={[
      "1) Prove that the wait-die and wound-wait protocols avoid deadlock and starvation",
      "2) Discuss the problems of deadlock and starvation and the different approaches to dealing with these problems",
      "3) How does the granularity of data items affect the performance of concurrency control? What factors affect the selection of granularity size for data items?",
      "4) Analyze the trade-offs between different locking mechanisms and deadlock prevention protocols in terms of concurrency, performance, and overhead. Consider a scenario of a distributed database system, which is used to manage airline reservations, might encounter a deadlock situation. Explain how binary locks, exclusive/shared locks, and deadlock prevention protocols could be used to prevent or resolve the deadlock."
    ]}
    exampleVideos={[]}
  />
);
}

export default DeadlocksTransactions;
